<template>
  <div class="videor" v-if="display">
    <div class="videor_close_container" @click="closeVideo">X</div>
    <div class="videor_container">
      <video ref="videoPlayer" style="position:absolute;top:10vh;left:0;width:100%;"></video>
      <div class="videor_container_btn_box">
        <div class="videor_container_btn">
          <i class="el-icon-close" @click="closeVideo"></i>
        </div>
        <div class="videor_container_btn">
          <i class="el-icon-video-play" v-if="!playing && !uploading" @click="videoStart"></i>
          <i class="el-icon-video-pause change_color" v-if="playing && !uploading" @click="videoStop"></i>
          <i class="el-icon-loading" v-if="uploading"></i>
        </div>
        <div class="videor_container_btn">
          <i class="el-icon-refresh" @click="videoSwitch" v-if="!playing && !uploading"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { uploadFile } from '../api/api';
  export default {
    name: "videor",
    data(){
      return {
        display:false,
        playing:false,
        uploading:true,
        faceMode:false,
        videoRecorder:null,
        recordedChunks:[],
        mediaStreamTrack:null,
        result:null,
        canUpload:false
      }
    },
    mounted(){

    },
    methods:{
      openVideor(){
        this.display = true;
        this.faceMode = false;
        this.videoInit();
      },
      closeVideo(){
        this.clearVideo();
        this.canUpload = false;
        this.faceMode = false;
        this.display = false;
      },
      clearVideo(){
        this.$refs.videoPlayer.srcObject = null;
        if(this.videoRecorder != null){
          this.videoRecorder.stop();
        }
        if(this.mediaStreamTrack!=null){
          this.mediaStreamTrack.getVideoTracks().forEach(track => {
            track.stop();
          });
        }
        this.mediaStreamTrack = null;
        this.videoRecorder = null;
        this.playing = false;
        this.uploading = false;
        this.recordedChunks = [];
      },
      async videoInit(){
        this.canUpload = true;
        this.recordedChunks = [];
        navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
        if(navigator.mediaDevices){
          let stream;
          try{
            stream = await navigator.mediaDevices.getUserMedia({audio:false,video:{facingMode:{exact:(this.faceMode ?  'user' : 'environment')}}});
          }catch(e){
            try{
              stream = await navigator.mediaDevices.getUserMedia({audio:false,video:{facingMode:(this.faceMode ?  'user' : 'environment')}});
            }catch (e2){
              try{
                stream = await navigator.mediaDevices.getUserMedia({audio:false,video:true});
              }catch (e3){
                this.$alert(e3.message,'错误提示',{
                  center:true,
                  type:'error',
                  confirmButtonText: '确定',
                  callback: action => {

                  }
                });
              }
            }
          }
          this.mediaStreamTrack = stream;
          this.videoRecorder = new MediaRecorder(stream,{mimeType:"video/webm"});
          this.videoRecorder.ondataavailable = (event)=>{
            if (event.data && event.data.size > 0) {
              this.recordedChunks.push(event.data);
            }
          };
          this.videoRecorder.onstop = ()=>{
            this.playing = false;
            this.uploading = true;
            let videoBlob = new Blob(this.recordedChunks, { type: "video/webm" });
            let file = new File([videoBlob], (new Date().valueOf())+'.webm', {
              type: videoBlob.type,
              lastModified: Date.now()
            });
            if(this.canUpload){
              let params = new FormData();
              params.append('files',file);
              uploadFile(params).then(res => {
                if(res && res.status === 0){
                  let data = res.data[0];
                  if(data && parseInt(data.status) === 0){
                    this.videoResult(data);
                    this.display = false;
                  }else{
                    this.$alert(data.message,'错误提示',{
                      center:true,
                      type:'error',
                      confirmButtonText: '确定',
                      callback: action => {

                      }
                    });
                  }
                }else{
                  this.$alert(res.message,'错误提示',{
                    center:true,
                    type:'error',
                    confirmButtonText: '确定',
                    callback: action => {

                    }
                  });
                }
              }).catch(e => {
                this.$alert(e.message,'错误提示',{
                  center:true,
                  type:'error',
                  confirmButtonText: '确定',
                  callback: action => {

                  }
                });
              }).finally(f => {
                this.uploading = false;
              });
            }
          };
          this.$refs.videoPlayer.srcObject = stream;
          this.$refs.videoPlayer.play();
          this.uploading = false
        }
      },
      videoSwitch(){
        this.clearVideo();
        this.uploading = true;
        this.faceMode = !this.faceMode;
        this.videoInit();
      },
      videoStart(){
        this.playing = true;
        this.videoRecorder.start();
      },
      videoStop(){
        this.mediaStreamTrack.getVideoTracks().forEach(track => {
          track.stop();
        });
        this.videoRecorder.stop();
        this.$refs.videoPlayer.srcObject = null;
      },
      videoResult(result){
        this.$emit('videoResult',result);
      }
    }
  }
</script>

<style scoped>
  .videor {
    position:absolute;
    top:0;
    left:0;
    display: inline-block;
    width:100%;
    height:94vh;
    background-color:rgba(0,0,0,0.9);
    z-index:99;
    overflow-y:scroll;
  }
  .videor_container {
    position:absolute;
    top:0;
    left:0;
    width:100%;
    height:94vh;
  }
  .videor_close_container {
    position:absolute;
    top:1vh;
    left:0;
    text-align:right;
    width:97%;
    margin-right:3%;
    font-size:1rem;
    color:white;
    cursor:pointer;
    z-index:999;
  }
  .videor_container_btn_box {
    position:absolute;
    top:70vh;
    left:0;
    width:100%;
    height:5rem;
    text-align:center;
  }
  .videor_container_btn {
    float:left;
    height:3rem;
    width:30%;
    margin-left:3%;
    line-height:3rem;
    border-radius:1.5rem;
    font-size:3rem;
    color:rgba(255,255,255,0.3);
  }
  .change_color {
    opacity: .1;
    animation: colorFadeIn 2s infinite forwards;
  }
  @keyframes colorFadeIn {
    0% {
      color:white;
      opacity: .6;
    }
    50% {
      color:red;
      opacity: .3;
    }
    100% {
      color:white;
      opacity: .6;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/videor.vue